import { render, staticRenderFns } from "./InfoSectionParts.vue?vue&type=template&id=4b01f178&"
import script from "./InfoSectionParts.vue?vue&type=script&lang=js&"
export * from "./InfoSectionParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports